import { Link } from 'react-router-dom'

import NotFoundImage from '@/assets/images/not-found.svg'
import { PageHeader } from '@/components/layout/page/page-header.tsx'
import { Page } from '@/components/layout/page/page.tsx'
import { Button } from '@/components/ui/button.tsx'
import { LicensesPageSkeleton } from '@/modules/licenses/components/licenses-page-skeleton.tsx'
import { LicensesTable } from '@/modules/licenses/components/licenses-table'
import { ModifyLicenseContext } from '@/modules/licenses/components/modify-license-context.tsx'
import { YourLicensesOption } from '@/modules/licenses/components/your-licenses-option.tsx'
import { useLicensesTable } from '@/modules/licenses/hooks/use-licenses-table.ts'
import { AppRoutes } from '@/utils/constants'

export const YourLicensesPage = () => {
  const {
    manageLink,
    licenseQuantity,
    licensesUsed,
    licensesTable,
    isFetching,
    licenses,
    plans,
  } = useLicensesTable()

  if (
    isFetching ||
    licensesTable == null ||
    licenses == null ||
    plans == null
  ) {
    return <LicensesPageSkeleton />
  }

  const noActiveLicenses = () => {
    return (
      <div className="flex flex-col items-center justify-center">
        <NotFoundImage className="min-w-[140px]" />
        <span className="text-2xl font-semibold text-text-default">
          No active licenses
        </span>
        <p className="text-text-sub">
          Get a license to connect a creator with CreatorHero
        </p>
        <Button className="mt-4">
          <Link to={AppRoutes.Licenses.Index.asUrl()}>Get now</Link>
        </Button>
      </div>
    )
  }

  return (
    <Page>
      <PageHeader
        title="Your Licenses"
        backToPage={{ name: 'Licenses', url: AppRoutes.Licenses.Index.asUrl() }}
      />
      <ModifyLicenseContext.Provider value={{ licenses, plans }}>
        {licenseQuantity === 0 ? (
          noActiveLicenses()
        ) : (
          <LicensesTable
            licenseQuantity={licenseQuantity}
            licensesUsed={licensesUsed}
            licensesTable={licensesTable}
          />
        )}
        <hr className="mt-10 h-[1px] border-t-0 bg-border" />
        <YourLicensesOption
          title="Manage Billing"
          description="Manage your billing information, subscriptions and payment history at our external payment provider."
          button={
            <Button
              className="w-28"
              isLoading={!manageLink}
            >
              <Link
                to={manageLink || ''}
                target="_blank"
              >
                Manage
              </Link>
            </Button>
          }
        />
      </ModifyLicenseContext.Provider>
    </Page>
  )
}
